import moment from 'moment';

export default {
    chart: {
        type: 'scatter'
    },
    yAxis: {
        tickInterval: 1
    },
    plotOptions: {
        scatter: {
            marker: {
                radius: 3
            }
        }
    },
    tooltip: {
        formatter() {
            return `${moment(this.x).format('dddd, MMM D, HH:mm')}<br>● Touch Count: <b>${this.y}</b>`;
        }
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/touch.js